export default __webpack_public_path__ + "assets/home2.cc2321bd.png";